<template>
  <div class="app-content">
    <div class="app-title mb10">
            <!-- 应用标题 -->
            <div class="app-titles">
                <i :class="currentSelectMenuData.css" class="app-title-icon"></i>
                <span class="app-title-main">{{currentSelectMenuData.name}}</span>
            </div>
            <!-- 列表按钮 -->
            <div class="app-buttons">
                <el-button icon="icon-save" class="btn-blue" size="mini" @click="save">
                    <font>保存</font>
                </el-button>
            </div>
        </div>
    <!-- <el-collapse v-model="activeNames">
      <el-collapse-item title="系统设置" name="1"> -->
        <div class="pl20 pr20 pt10 pb10">
        <el-row :gutter="20">
          <el-col :span="12">
            <p>首页Logo</p>
            <el-button type="warn" round class="a-upload" style="width: 100%; position: relative;">
              <img v-if="dataInfo.indexlogo" :src="dataInfo.indexlogo" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <input id="excelFile1" type="file" name="uploadFile1" @change="upload1" class="largeImg" />
            </el-button>
          </el-col>
          <el-col :span="12">
            <p>登录页Logo</p>
            <el-button type="warn" round class="a-upload" style="width: 100%; position: relative;">
              <img v-if="dataInfo.loginlogo" :src="dataInfo.loginlogo" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <input id="excelFile2" type="file" name="uploadFile2" @change="upload2" class="largeImg" />
            </el-button>
          </el-col>
        </el-row>
        <el-row class="pt20">
          <el-col :span="24">
            <p>登录页版权</p>
            <el-input type="textarea" v-model="dataInfo.copyright" placeholder="例：Copyright © XXXX公司 All Rights Reserved." :autosize="{ minRows:3}"></el-input>
          </el-col>
        </el-row>
        <el-form inline-message :model="dataInfo">
          <el-row>
              <el-col :span="12">
                <el-form-item label="登录验证码?" label-width="100px">
                  <el-switch v-model="dataInfo.identifyingcode" :active-value="'1'" :inactive-value="'0'" active-color="#8996f1" ></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="用户第一次登录是否初始化密码?" label-width="220px">
                  <el-switch v-model="dataInfo.firstlogininit" :active-value="1" :inactive-value="0" active-color="#8996f1" ></el-switch>
                </el-form-item>
              </el-col>
          </el-row>
        </el-form>
        </div>
      <!-- </el-collapse-item>
    </el-collapse> -->
  </div>
</template>

<script>
// indexLogo  首页logo     loginLogo  登录页logo   loginCopyright 登录页版权

import { Loading } from 'element-ui'
export default {
  name: 'systemSet',
  data() {
    return {
      activeNames: ['1'],
      dataInfo: {
        indexPageLogo: '',
        loginPageLogo: '',
        loginPageCopyright: '',
        firstlogininit:0,
        identifyingcode:'0',
      },
      basic_url: Config.dev_url,
    }
  },
  methods: {
    getData() {
      var url = Config.dev_url + '/api-user/settings'
      this.$axios.get(url).then((res) => {
        console.log(res,"登录页面logo与版权")
        this.dataInfo = res.data
        // this.$store.dispatch('setSystemSetInfoAct', res.data);
      }).catch((err) => {
                });
    },
    upload1() {
      var files = document.getElementById('excelFile1').files[0]
      console.log(files)
      if (files.size > 512000) {
        this.$message.warning('上传的图片大小不能超过500kb')
        return;
      }
      if (files !== undefined) {
        var reader = new FileReader();
        reader.readAsDataURL(files);
        var that = this;
        reader.onload = function () {
          var binaryStreamFile = this.result
          // that.dataInfo.indexPageLogo = binaryStreamFile
          that.$set(that.dataInfo,'indexlogo',binaryStreamFile)
          console.log(that.dataInfo.indexPageLogo)
        }
      }
    },
    upload2() {
      var files = document.getElementById('excelFile2').files[0]
      if (files.size > 512000) {
        this.$message.warning('上传的图片大小不能超过500kb')
        return;
      }
      if (files !== undefined) {
        var reader = new FileReader();
        reader.readAsDataURL(files);
        var that = this
        reader.onload = function () {
          var binaryStreamFile = this.result
          // that.dataInfo.loginPageLogo = binaryStreamFile
          that.$set(that.dataInfo,'loginlogo',binaryStreamFile)
        }
      }
    },
    save() {
      var loading = Loading.service({
        fullscreen: true,
        text: '拼命上传中...',
        background: 'rgba(F,F, F, 0.8)'
      });
      // console.log(this.dataInfo)
      var url = Config.dev_url + '/api-user/settings/saveOrUpdate'
      this.$axios.post(url, this.dataInfo).then((res) => {
        console.log(res)
        loading.close()
        if (res.data.resp_code == 0) {
          this.$message.success('操作成功')
          this.getData()
        }else{
           this.$message.warning(res.data.resp_msg)
        }
      }).catch((err) => {
                });
    }
  },
  mounted() {
    this.getData()
  },
  computed:{
      //当前左侧菜单选中的信息
      currentSelectMenuData(){
          return this.$store.state.currentSelectMenuData
      },
      //列表显示的按钮
      listButtons(){
          return this.$store.state.buttons
      },
      //当前登录人信息
      currentuser() {
          return this.$store.state.currentuser
      },
  },
}
</script>

<style scoped>
.a-upload{
  height: 180px;
}
.a-upload input[type="file"]{
  top: -30px;
}
</style>